import { render, staticRenderFns } from "./TCD.vue?vue&type=template&id=6fd9ffc4&scoped=true&"
import script from "./TCD.vue?vue&type=script&lang=js&"
export * from "./TCD.vue?vue&type=script&lang=js&"
import style0 from "./TCD.vue?vue&type=style&index=0&id=6fd9ffc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd9ffc4",
  null
  
)

export default component.exports